import styled from '@emotion/styled';
import React from 'react';

const StyledListContainer = styled.div<{ cardWidth: number }>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 8px;
    column-gap: 16px;
    row-gap: 14px;
    width: 100%;
    max-height: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${(props) => props.cardWidth || 100}px, 1fr));
    grid-auto-rows: 72px;
`;

export const ListContainer = ({ children, cardWidth, listRef }: { children: React.ReactNode; cardWidth: number; listRef: React.MutableRefObject<null>; }) => {
  return (
    <div className='find-user-list-wrapper'>
      <StyledListContainer cardWidth={cardWidth} ref={listRef}>
        {children}
      </StyledListContainer>
    </div>
  );
};
